import React from "react";

export default function TwentyTwo({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path
        id="FrameBody"
        d="M292,77.83H161.75a7.07,7.07,0,0,0-7.09,7.09V215.08a7.1,7.1,0,0,0,7.09,7.09H291.91a7.13,7.13,0,0,0,7.14-7V84.92A7.1,7.1,0,0,0,292,77.83ZM295.77,215a4,4,0,0,1-4,4h-130a3.94,3.94,0,0,1-3.95-4V85a3.94,3.94,0,0,1,3.95-4h130a4,4,0,0,1,4,4Z"
      />
      <path d="M117.81,187.78a1.85,1.85,0,0,1-1.09-3.33,112.61,112.61,0,0,0,13.94-11.9C87.23,188.17,55.32,187,35.94,183.16,14,178.78,3.05,170.24,2.6,169.88A1.84,1.84,0,1,1,4.89,167c.1.08,10.83,8.42,32,12.6,19.06,3.75,50.6,4.78,93.72-11-8.14-.79-20.18.38-20.31.4a1.84,1.84,0,0,1-.37-3.67c.65-.06,15.81-1.53,24.12,0a3.32,3.32,0,0,1,2.93,2.49c.41,1.81-.33,4.67-8.94,12.17-4.48,3.9-9,7.23-9.18,7.37A1.85,1.85,0,0,1,117.81,187.78Z" />
      {children}
    </svg>
  );
}
